import classNames from 'classnames'

import {AddressShape} from '../../PropTypes.js'
import Icon from '../../icons/Icon.js'

const VALIDATION_ICONS = {
  error: 'ban',
  warning: 'exclamation-triangle',
}

export default function AddressValidationIcon({address}) {
  const validationStatus = address.validation && address.validation.status

  return (
    <div className={classNames('wrap--address-validation', validationStatus)}>
      {['warning', 'error'].includes(validationStatus) && (
        <div
          className="tooltip--top"
          data-hint={address.validation.additional_text}
        >
          <Icon
            name={VALIDATION_ICONS[validationStatus]}
            className="fs-00 margin-right-3"
          />
        </div>
      )}
    </div>
  )
}

AddressValidationIcon.propTypes = {
  address: AddressShape.isRequired,
}
